import React, { useState, useEffect } from "react";
import { MdOutlineRefresh } from "react-icons/md";
import Axios from "axios";

const Captcha = () => {

    const [captchaImage, setCaptchaImage] = useState();

    const getCapcha = () => {

        Axios.get(`${process.env.REACT_APP_BASE_URL}/captcha`, {
            responseType: "blob", withCredentials: true
        })
            .then((response) => {
                const urlData = window.URL.createObjectURL(response.data);
                setCaptchaImage(urlData);
            })
            .then((error) => {
                console.warn(error);
            });
    };

    useEffect(() => {
        getCapcha();
    }, []);

    return (
        <div className="captcha">
            <img src={captchaImage} alt='captchaImage' className='captcha-image' />
            <div onClick={getCapcha} className="captchaRefresh">
                <MdOutlineRefresh title='Refresh Captcha' />Refresh</div>
        </div>
    )
}
export default Captcha;